import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-left-icon',
  standalone: true,
  templateUrl: './chevron-left-icon.component.html',
})
export class ChevronLeftIconComponent {}
